export default __webpack_public_path__ + "static/media/logo-earth.d6409997.png";